import { statsChartOutline } from "ionicons/icons";

/**
 * Server-rendered idle screen styles a device can be pinned to; `null` on the
 * device means the fleet default. Ids are the render service's template ids
 * (Device.screenTemplate). Add a style here to list it in the picker.
 */
export const SCREEN_TEMPLATES = [
    {
        id: '5a',
        icon: statsChartOutline,
        labelKey: 'screen_templates.5a',
        noteKey: 'device_screen.activity_board_note',
    },
] as const;

export type ScreenTemplateId = (typeof SCREEN_TEMPLATES)[number]['id'];

export const screenTemplateById = (id: string | null | undefined) =>
    SCREEN_TEMPLATES.find((template) => template.id === id);
